export function snakeToHumanCase(value: string) {
    return value
        .split('_')
        .map((v) => {
            return v[0].toUpperCase() + v.substr(1)
        })
        .join(' ')
}
